import React from 'react';
import { offerAnchor, volumes } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, Mark, SectionLead, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-273" data-mp="184ohyxrjo8zz">
      <div className="mx-auto max-w-3xl" data-id="element-274" data-mp="182298usx3ng6">
        <Eyebrow data-id="element-275" data-mp="1c4p83fo0a8mv">What's included</Eyebrow>
        <SectionTitle data-id="element-276" data-mp="1c5ql3pol1578">
          5 complete volumes. <Mark data-id="element-277" data-mp="1zujizrorln4h">50 beautiful bag designs.</Mark>
        </SectionTitle>
        <SectionLead data-id="element-278" data-mp="1zt8fzu358jef">
          From everyday favorites to eye-catching statement pieces, explore a variety of crochet handbag styles.
        </SectionLead>

        <ul className="mt-8 space-y-5" data-id="element-279" data-mp="1qtlaaw3dsrfk">
          {volumes.map(volume => <li key={volume.number} className="overflow-hidden rounded-2xl border border-berry-600/15 shadow-sm" data-id="element-280" data-mp="1vsogijv3l3p4">
              <div className="flex items-center gap-3 bg-berry-600 px-4 py-3 md:px-5" data-id="element-281" data-mp="feetbt2ldkzv">
                <span className="shrink-0 rounded-md bg-white px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-berry-700 md:text-[11px]" data-id="element-282" data-mp="kekmxesf9hkl">
                  Volume {volume.number}
                </span>
                <h3 className="text-sm font-black uppercase leading-tight text-white md:text-base" data-id="element-283" data-mp="3jadffgvasu79">{volume.name}</h3>
              </div>
              <div className="bg-white px-4 py-4 md:px-5" data-id="element-284" data-mp="1ylx4r46t0wv">
                <p className="text-sm font-bold leading-relaxed text-plum-950 md:text-base" data-id="element-285" data-mp="3t6glgxt9tczh">{volume.subtitle}</p>
                <div className="mt-2 space-y-1.5 text-sm leading-relaxed text-muted" data-id="element-286" data-mp="aztt32j8dpns">
                  {volume.description.map(paragraph => <p key={paragraph} data-id="element-287" data-mp="kr6ilnhk43qn">{paragraph}</p>)}
                </div>
                <p className="mt-4 text-[11px] font-extrabold uppercase tracking-wider text-berry-700" data-id="element-288" data-mp="fsmyztqfr41g">
                  Your 10 patterns:
                </p>
                <ol className="mt-2 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-289" data-mp="tse5zaijbk5y">
                  {volume.items.map((item, index) => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-plum-950" data-id="element-290" data-mp="wtzgytfxiebi" data-mpi={index}>
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blush-200 text-[10px] font-black tabular-nums text-plum-950" data-id="element-291" data-mp="11saqt4684otq">
                        {index + 1}
                      </span>
                      {item}
                    </li>)}
                </ol>
                <p className="mt-4 text-sm leading-relaxed text-muted" data-id="element-292" data-mp="1fj783yup9jlh">{volume.details}</p>
                <p className="mt-3 text-[11px] font-black uppercase tracking-wider text-berry-700" data-id="element-293" data-mp="1kiimx2biaf0f">{volume.tagline}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-294" data-mp="1uh80iiwdddav">
          <Button href={offerAnchor} size="lg" subtext="Get all 5 volumes + 5 free bonus books at today's price" data-id="element-295" data-mp="1ugzkii4y9rvg">
            Yes! Unlock all 50 bag patterns
          </Button>
        </div>
      </div>
    </section>;
}